import http from '../../http'
import { API_URL } from '../../const'

export const updateVerificationFields = (actityType: string, activityId: string, data: any) =>
  http.put(`${API_URL}/${actityType}/verify/${activityId}`, { data })
